module.exports = __webpack_public_path__ + "img/volkswagen-logo.b3d49ec0.png";